/* istanbul ignore file */
import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = theme;

/* Matches the space around the breadcrumbs on the Inspiration hub. */
export const breadcrumbs = css`
  padding: var(${themeVariables.spacing.lg}) 0 var(${themeVariables.spacing.md});
`;

export const container = css`
  *:not([data-section-name]) + [data-section-name='section_title'] {
    margin-top: ${spacing.xxl}px;

    ${mediaQuery(
      { min: minBreakpoints.L },
      css`
        margin-top: ${pxToRem(56)};
      `,
    )}
  }
`;
